/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import 'regenerator-runtime/runtime.js';
import { DrawPadWrapper } from './DrawPad/DrawPadWrapper';
import { SignaturePadProvider } from './Provider/SignaturePadProvider';

const drawPadWrapper = document.querySelectorAll('.draw-pad-wrapper');

drawPadWrapper.forEach((drawPad) => {
  const root = ReactDOM.createRoot(drawPad); // Erstellen einer neuen Root
  root.render(
    <SignaturePadProvider>
      <DrawPadWrapper
        fileUri={drawPad.dataset.uri}
        workerScriptUri={drawPad.dataset.workerScript}
      />
    </SignaturePadProvider>,
  );
});
